import React from 'react'
import * as css from '../../FondosAsignados.css'
//Componentes
import { RowGastos } from './RowGastos.jsx'

export class TablaGastos extends React.Component{
    constructor(props){
        super(props)
    }
    render() {
        let cantidadGastos = this.props.gastos.length
        return (
            <div className="row">
                {cantidadGastos > 0?
                        <TablaGasto>
                            {_.range(0, cantidadGastos).map(index=>{
                                let gasto = this.props.gastos[index]
                                return <RowGastos
                                    key={index}
                                    index={index}
                                    gasto={gasto}
                                />
                            })}
                        </TablaGasto>
                    :
                        null
                }
            </div>
        )
    }
}
let TablaGasto = ({children}) =>
    <div className="table-responsive">
        <table className={"table table-condensed "+css.tableFixed}>
            <thead>
                <tr>
                    <th className={css.thIndex}></th>
                    <th className={css.thFechaGasto}>Emisión</th>
                    <th className={"hidden-xs "+css.thTipoGasto}>Tipo Gasto</th>
                    <th className={css.thEstadoGasto}>Estado</th>
                    <th className={"hidden-xs "+css.thGlosa}>Comentarios</th>
                    <th className={css.thTotal}>Total</th>
                    <th className={"hidden-xs "+css.thAcciones}/>
                </tr>
            </thead>
            <tbody>
                {children}
            </tbody>
        </table>
    </div>


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/gastos/TablaGastos.jsx